<template>
  <bids-view
    class="content"
    :override-list-configuration="listConfiguration"
    @crud-list:items-updated="updateItemsCount" />
  <div v-if="itemsCount > 0" class="see-all text-center">
    <saffron-link :to="linkTo">{{ t("justopp.bids.seeBidsCta") }}</saffron-link>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import BidsView from "@/client/applications/justopp/views/Bids";

export default {
  components: { BidsView },
  props: {
    linkTo: {
      type: Object,
      default: () => ({
        name: "user-dashboard-bids",
      }),
    },
    constantFilters: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    return {
      itemsCount: 0,
      listConfiguration: {
        showIdField: false,
        fields: {
          createdAt: {
            itemKey: "createdAt",
            label: "justopp.bid.fields.createdAt",
            filterable: false,
            orderable: false,
          },
          amount: {
            name: "amount",
            label: "justopp.bid.fields.amount",
            orderable: false,
          },
          productName: {
            name: "productName",
            label: "justopp.bid.fields.productName",
            orderable: false,
          },
          isWinning: {
            label: "justopp.bid.fields.isWinning",
            orderable: false,
          },
        },
        actions: false,
        paginationConfig: {
          start: 0,
          limit: 3,
          show: false,
        },
        constantFilters: this.constantFilters,
      },
    };
  },
  computed: {},
  methods: {
    updateItemsCount(items) {
      if (items) {
        this.itemsCount = items.length;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
